/* GUMÉA PARIS — Theme JS (ported structure from Fitgum, gp- namespace) */
document.addEventListener('DOMContentLoaded', function() {

  /* SCROLL PROGRESS + HEADER */
  var prog = document.getElementById('gp-prog');
  var hdr = document.getElementById('gp-header');
  var sections = ['gp-produits','gp-bundle-teaser','gp-comparison','gp-avis','gp-faq'];
  window.addEventListener('scroll', function() {
    if (prog) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.width = (window.scrollY / h * 100) + '%';
    }
    if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 10);
    sections.forEach(function(id) {
      var el = document.getElementById(id);
      var a = document.querySelector('.gp-nav-links[data-section="' + id + '"]');
      if (!el || !a) return;
      var top = el.offsetTop - 80;
      a.classList.toggle('gp-on', window.scrollY >= top && window.scrollY < top + el.offsetHeight);
    });
    /* STICKY ATC */
    var atc = document.getElementById('gp-atc-main');
    var sticky = document.getElementById('gp-sticky-atc');
    if (atc && sticky) sticky.classList.toggle('gp-sticky-atc--visible', atc.getBoundingClientRect().top < 0);
  }, {passive: true});

  /* MOBILE NAV */
  window.gpToggleMob = function() {
    var ham = document.getElementById('gp-ham');
    var mob = document.getElementById('gp-mob');
    if (!ham || !mob) return;
    ham.classList.toggle('gp-open');
    mob.classList.toggle('gp-open');
    document.body.style.overflow = mob.classList.contains('gp-open') ? 'hidden' : '';
  };

  /* FAQ */
  window.gpFaq = function(btn) {
    var item = btn.closest('.gp-faq__item');
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.gp-faq__item').forEach(function(i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  };

  /* PRODUCT TABS */
  window.gpTab = function(btn, id) {
    document.querySelectorAll('.gp-tab-btn').forEach(function(b) { b.classList.remove('active'); });
    document.querySelectorAll('.gp-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var el = document.getElementById(id);
    if (el) el.classList.add('active');
  };

  /* CART QTY (dedicated /cart page — distinct from gumea.js's drawer gmQty) */
  window.gpQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: parseInt(qty)})
    }).then(function() { location.reload(); });
  };

  /* BUNDLE ADD ALL */
  window.gpAddBundle = function(ids) {
    var items = ids.map(function(id) { return {id: id, quantity: 1}; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: items})
    }).then(function() { window.location.href = '/cart'; });
  };

  /* ATC FEEDBACK */
  document.querySelectorAll('.gp-prod-atc-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      var orig = btn.innerHTML;
      btn.innerHTML = '✓ Ajouté';
      btn.style.background = '#2F6B3A';
      setTimeout(function() { btn.innerHTML = orig; btn.style.background = ''; }, 2000);
    });
  });

  /* STOCK BARS ANIMATION */
  var stockObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        var bars = e.target.querySelectorAll('.gp-stock-bar');
        bars.forEach(function(bar) {
          setTimeout(function() { bar.style.width = bar.getAttribute('data-width'); }, 300);
        });
        stockObs.unobserve(e.target);
      }
    });
  }, {threshold: 0.2});
  document.querySelectorAll('.gp-produits').forEach(function(el) { stockObs.observe(el); });

  /* SMOOTH SCROLL */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({behavior: 'smooth', block: 'start'});
      var mob = document.getElementById('gp-mob');
      if (mob && mob.classList.contains('gp-open')) window.gpToggleMob();
    });
  });

});
